import { api } from './api';

export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get dashboard metrics
    getMetrics: builder.query({
      query: () => '/dashboard/metrics',
      providesTags: ['Dashboard'],
      // Cache for 5 minutes, refetch on focus
      keepUnusedDataFor: 300,
    }),

  }),
});

export const { useGetMetricsQuery } = dashboardApi;
